module.exports = __webpack_public_path__ + "b85d120b1fb913365b79ed6ec7df2d10.pdf";